module.exports = __webpack_public_path__ + "images/2cb482bc583b2a0b17bd55f2d1dc13488.svg";